import { flagFactory } from '../icon';
import Svg from './pl.svg';

export default flagFactory(Svg);
